import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Cookies from 'js-cookie';

import { Routes, Route } from 'react-router-dom';
import Dashboard from './screens/dashboard/dashboard';
import ModulesDash from './screens/modules/ModuleDash';
import AssignmentDash from './screens/assignments';
import ContestDash from './screens/contests';
import LiveDoubtDash from './screens/livedoubts/LiveDoubtsDash';
import GymDash from './screens/gym/GymDash';
import GymAptitute from './screens/gym-aptitute/aptitude';
import Softskills from './screens/softskills';
import Onevone from './screens/1v1/1v1';
import ReferAndEarn from './screens/ReferAndEarn/ReferAndEarn';

import GithubAuthRedirect from './screens/webdevidle/GithubAuthRedirect';

import { fetchCourseList, fetchUserReport } from './redux/user/userSlice';
import { fetchCourseData, getLeaderBoard } from './redux/course/courseSlice';

import IDEScreen from './screens/IDEScreen/IDEScreen';
import WebDevScreen from './screens/webdevidle/WebDevScreen';
import WebDevEditor from './screens/webdevidle/WebDevEditor';
import FileExplorer from './screens/notes/FileExplorer';
import ContestInfo from './screens/contests/contestInfo';
import LeaderboardMain from './screens/contests/leaderboard';
import OpenCodeEditor from './screens/OpenCodeEditor/OpenCodeEditor';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PageNotFound from './screens/pagenotfound/PageNotFound';
import CalenderView from './screens/calender/Calender';
import Aptitude from './screens/aptitute/aptitude';
import ProjectsPage from './screens/projects/ProjectsPage';
import StartProjectPage from './screens/startproject/StartProjectPage';
import JobPortal from './screens/jobportal/jobportal';
import Profile from './screens/profile/Profile';

const AppRouter = () => {
	// const dispatch = useDispatch();
	//
	// const courseState = useSelector((state: any) => state.course);
	// const { courseID, courseloading } = courseState;
	//
	// const userState = useSelector((state: any) => state.user);
	// const { latestCourseID, userDataStatus, userCourseStatus } = userState;
	//
	// useEffect(() => {
	// 	if (!userDataStatus || !userCourseStatus) {
	// 		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// 		// @ts-ignore
	// 		dispatch(fetchUserReport());
	// 		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// 		// @ts-ignore
	// 		dispatch(fetchCourseList());
	// 		console.log('Hello');
	// 	}
	// }, []);
	//
	// useEffect(() => {
	// 	if (courseID === null && latestCourseID !== null) {
	// 		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// 		// @ts-ignore
	// 		dispatch(fetchCourseData());
	// 	}
	// }, [latestCourseID]);
	//
	// useEffect(() => {
	// 	if (courseID !== null) {
	// 		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// 		// @ts-ignore
	// 		dispatch(getLeaderBoard());
	// 	}
	// }, [courseID]);

	return (
		<Routes>
			<Route
				path={'/'}
				element={<Dashboard />}
			/>
			<Route
				path={'/home'}
				element={<Dashboard />}
			/>
			<Route
				path={'/modules'}
				element={<ModulesDash />}
			/>
			{/*<Route*/}
			{/*	path={'/assignments'}*/}
			{/*	element={<AssignmentDash />}*/}
			{/*/>*/}
			<Route
				path={'/contests'}
				element={<ContestDash />}
			/>
			<Route
				path={'/live-doubts'}
				element={<LiveDoubtDash />}
			/>
			<Route
				path={'/gym'}
				element={<GymDash />}
			/>
			<Route
				path={'/gym-aptitude'}
				element={<GymAptitute />}
			/>
			<Route
				path={'/notes'}
				element={<FileExplorer />}
			/>
			<Route
				path={'/notes/:slug'}
				element={<FileExplorer />}
			/>
			<Route
				path={'/job-portal'}
				element={<JobPortal />}
			/>
			<Route
				path={'/profile'}
				element={<Profile />}
			/>
			<Route
				path={'/softskills'}
				element={<Softskills />}
			/>
			<Route
				path={'/profile'}
				element={<Profile />}
			/>
			<Route
				path={'/softskills'}
				element={<Softskills />}
			/>
			<Route
				path={'/idle'}
				element={<IDEScreen />}
			/>
			<Route
				path={'/web-idle'}
				element={<WebDevScreen />}
			/>
			<Route
				path={'/open-web-editor'}
				element={<WebDevEditor />}
			/>
			<Route
				path="/github/auth"
				element={<GithubAuthRedirect />}
			/>
			<Route
				path="/onevone"
				element={<Onevone />}
			/>
			<Route
				path={'/contest'}
				element={<ContestInfo />}
			/>
			<Route
				path={'/open-editor'}
				element={<OpenCodeEditor />}
			/>
			<Route
				path={'/aptitude'}
				element={<Aptitude />}
			/>
			<Route
				path={'/refer-and-earn'}
				element={<ReferAndEarn />}
			/>
			<Route
				path={'*'}
				element={<PageNotFound />}
			/>
			<Route
				path={'/mycalendar'}
				element={<CalenderView />}
			/>
			<Route
				path={'/projects'}
				element={<ProjectsPage />}
			/>
			<Route
				path={'/start-project'}
				element={<StartProjectPage />}
			/>
			<Route
				path="/leaderboard"
				element={<LeaderboardMain />}
			/>
		</Routes>
	);
};

export default AppRouter;
